// KR lower row swaps branches/leaves in place; real collection anchors stay native.
const controllers = new Map();
function mount(scope = document) {
  for (const root of scope.querySelectorAll('[data-hv-mobile-shop]')) {
    if (controllers.has(root)) continue;
    const events = new AbortController();
    controllers.set(root, events);
    const row = root.querySelector('[data-shop-row]');
    row.addEventListener('click', event => {
      const branch = event.target.closest('[data-shop-branch]');
      const back = event.target.closest('[data-shop-back]');
      if (!branch && !back) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const gender = branch?.dataset.shopBranch || row.dataset.shopGender;
      const template = branch ? root.querySelector(`[data-shop-leaves="${gender}"]`) : root.querySelector('[data-shop-branches]');
      if (!template) return;
      event.preventDefault();
      row.replaceChildren(template.content.cloneNode(true));
      row.scrollLeft = 0;
      if (branch) {
        row.dataset.shopGender = gender;
        row.querySelector('[data-shop-back]')?.focus({preventScroll:true});
      } else {
        delete row.dataset.shopGender;
        row.querySelector(`[data-shop-branch="${gender}"]`)?.focus({preventScroll:true});
      }
    }, {signal:events.signal});
  }
}
mount();
document.addEventListener('shopify:section:load', event => mount(event.target));
document.addEventListener('shopify:section:unload', event => {
  for (const [root, events] of controllers) if (event.target.contains(root)) {
    events.abort(); controllers.delete(root);
  }
});
